import { makeStyles } from "@material-ui/core/styles";

const UseStyles = makeStyles((theme) => ({
	main_grid: {
		backgroundColor: "#F5F5F5",
	},
	cell_header_bold: {
		// width: 300,
		color: "black",
		fontWeight: "bold",
		fontSize: "0.85rem !important",
	},

	header_bold: {
		color: "black",
		fontWeight: "bold",
		fontSize: "0.85rem !important",
	},
	saveButton: {
		backgroundColor: "#022F40 !important",
		color: "white",
	},
	saveButtonDisalbe: {
		backgroundColor: "#cccccc",
		color: "#666666",
		cursor: "not-allowed !important",
	},
	grid_space: {
		marginTop: 20,
		marginBottom: 20,
		backgroundColor: "#F5F5F5",
	},
	grid_space_modal: {
		marginTop: 5,
		marginBottom: 5,
	},

	text_color_set: {
		color: "gray",
	},

	row_color1: {
		backgroundColor: "#FFFFFF",
		color: "white",
	},
	row_color2: {
		backgroundColor: "#F5F5F5",
	},
	box_design: {
		border: "3px solid rgba(224, 224, 224, 1)",
		padding: 5,
		borderRadius: 20,
	},
	gridSize: {
		minWidth: 860,
	},

	headerText: {
		display: "inline-block",
		color: "#000000",
		fontSize: "1.2rem !important",
	},
	materialbtn_response: {
		borderRadius: "3px",
		color: "#19A2E5 !important",
		fontSize: "0.650rem !important",
		width: "20px",
		cursor: "pointer !important",
	},
	btn_response: {
		backgroundColor: "#F6FAFD !important",
		borderColor: "#19A2E5 !important",
		fontWeight: "bold",
		borderRadius: "3px",
		color: "black !important",
		padding: "8px 8px !important",
		fontSize: "0.750rem !important",
		cursor: "pointer !important",
		marginLeft: "2px",
		marginRight: "2px",
	},
	btn_responseYes: {
		marginleft: "2px",
		marginRight: "2px",
		fontWeight: "bold",
		backgroundColor: "#53cd37 !important",
		color: "#ffffff",
		borderColor: "#53cd37 !important",
		borderRadius: "3px",
		padding: "8px 8px !important",
		fontSize: "0.750rem !important",
		cursor: "pointer !important",
	},
	btn_responseNo: {
		marginLeft: "2px",
		marginRight: "2px",
		fontWeight: "bold",
		backgroundColor: "red !important",
		borderColor: "red !important",
		borderRadius: "3px",
		color: "white !important",
		padding: "8px 8px !important",
		fontSize: "0.750rem !important",
		cursor: "pointer !important",
	},
	btn_responseNA: {
		marginLeft: "2px",
		marginRight: "2px",
		fontWeight: "bold",
		backgroundColor: "#0e80e5 !important",
		borderColor: "#0e80e5 !important",
		borderRadius: "3px",
		color: "white !important",
		padding: "8px 8px !important",
		fontSize: "0.750rem !important",
		cursor: "pointer !important",
	},
	show_status: {
		width: "100%",
	},

	Completed: {
		/* background-color: #2e8a19 !important, */
		backgroundColor: "#53cd37 !important",
		borderRadius: "3px",
		color: "#ffffff",
		borderColor: "#53cd37 !important",
		padding: "8px",
		fontSize: "0.75rem !important",
	},
	Open: {
		/* background-color: #9a0200 !important, */
		backgroundColor: "red !important",
		borderRadius: "3px",
		color: "#ffffff",
		borderColor: "red !important",
		padding: "8px",
		fontSize: "0.75rem !important",
	},
	Not_Applicable: {
		backgroundColor: "#0e80e5 !important",
		borderRadius: "3px",
		color: "#ffffff",
		borderColor: "#0e80e5 !important",
		padding: "8px",
		fontSize: "0.75rem !important",
	},
	editItems: {
		display: "flex",
		flexDirection: "row",
	},
	buttonSet: {
		cursor: "pointer",
		backgroundColor: "#53CD37",
		color: "#FFFFFF",
		borderRadius: "4px",
		textTransform: "capitalize",
	},
	closeButton: {
		color: "white",
		backgroundColor: "red",
		textTransform: "capitalize",
		marginLeft: "4px",
		borderRadius: "4px",
	},
	modalHeader: {
		backgroundColor: "#4ba0d820",
		borderTopLeftRadius: "5px",
		borderTopRightRadius: "5px",
		position: "relative",
	},
	modalBackground: {
		backgroundColor: theme.palette.background.paper,
	},
	button: {
		cursor: "pointer",
		borderRadius: "4px",
		textTransform: "capitalize",
	},
	addButton: {
		backgroundColor: "#3f51b5",
		color: "white",
		borderRadius: "4px",
		padding: "5px",
	},
	table: {
		"& th": {
			padding: "0.25rem 0.5rem",
			lineHeight: "1.2rem !important",
			fontSize: "0.75rem !important",
			fontWeight: "bold",
			color: "black",
			borderRight: "0.5px solid rgba(224, 224, 224, 1) !important",
			borderTop: "0.5px solid rgba(224, 224, 224, 1) !important",
			// display: "table-header-group",
		},
		"& td": {
			padding: "0.25rem 0.5rem",
			lineHeight: "1.2rem !important",
			fontSize: "0.75rem !important",
			borderRight: "0.5px solid rgba(224, 224, 224, 1) !important",
			color: "black",
		},
		"& tr:nth-child(even)": {
			backgroundColor: "#F9F9F9",
		},
	},
	reportTable: {
		"& thead": {
			display: "table-row-group",
		},
		"& th": {
			padding: "0.25rem 0.5rem",
			lineHeight: "1rem !important",
			fontSize: "0.75rem !important",
			fontWeight: "bold",
			color: "black",
			borderRight: "1px solid #000000 !important",
			borderTop: "1px solid #000000 !important",
			borderLeft: "1px solid #000000 !important",
			borderBottom: "1px solid #000000 !important",
			pageBreakInside: "avoid",
		},
		"& td": {
			padding: "0.25rem 0.5rem",
			lineHeight: "1rem !important",
			fontSize: "0.75rem !important",
			borderRight: "1px solid #000000 !important",
			borderTop: "1px solid #000000 !important",
			borderLeft: "1px solid #000000 !important",
			borderBottom: "1px solid #000000 !important",
			color: "black",
			wordBreak: "break-all",
			pageBreakInside: "avoid",
		},
		"& tr": {
			pageBreakBefore: "always",
			pageBreakAfter: "always",
			pageBreakInside: "avoid",
		},
		wordWrap: "break-word",
	},
	tableApplicant: {
		"& th": {
			padding: "0.25rem 0.5rem",
			fontSize: "0.75rem !important",
			lineHeight: "1.2rem !important",
		},
		"& td": {
			padding: "0.25rem 0.5rem",
			lineHeight: "1.2rem !important",
			fontSize: "0.75rem !important",
		},
		"& tr:nth-child(even)": {
			backgroundColor: "#F9F9F9",
		},
	},

	tableShadow: {
		boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
		padding: "1rem",
	},
	textFieldDesign: {
		fontSize: "0.75rem !important",
		color: "black",
	},
	tableContainer: {
		boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
		padding: "0.5rem",
	},
	lastPannel: {
		padding: "1.5rem",
		marginTop: "15px",
	},
	iconDisable: {
		backgroundColor: "#819BB6 !important",
		color: "white",
		borderRadius: "4px",
		padding: "5px",
	},
}));

export default UseStyles;
